import React, { useState } from "react";
import "./forgot.scss";
import Navbar from "../landing/header/Navbar";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { Api_Url } from "../../utils/ApiUrl";
import { toast } from "react-toastify";

const New_Admin_Password = () => {
  const [loader, setLoader] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const history = useHistory();

  function validatePassword(password) {
    // At least 8 characters long
    if (password.length < 8) return false;

    // At least one uppercase letter
    if (!/[A-Z]/.test(password)) return false;

    // At least one special character
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) return false;

    return true;
  }

  const ResetPassword = async () => {
    var val = window.location.href;
    val = new URL(val);
    var tok = val.searchParams.get("token");
    const data = {
      password: password,
      confirmPassword: confirmPassword,
      token: tok,
    };
    let isValid = validatePassword(password);
    if (isValid) {
      // Fix here - we want to proceed if the password is valid
      if (password === confirmPassword) {
        setLoader(true);
        await axios
          .post(`${Api_Url}/auth/users/admin/reset-password`, data)
          .then((res) => {
            toast.success("Password updated successfully!");
            setLoader(false);
            history.push("/login");
          })
          .catch((err) => {
            toast.error(err?.response?.data.message, {
              position: "top-right",
              autoClose: 2000,
            });
            setLoader(false);
          });
      } else {
        toast?.error("Password's do not match!");
      }
    } else {
      toast?.error("Password does not match requirements!");
    }
  };

  return (
    <>
      <div className="forgotpassword-wrapper">
        <img src="/leftshade.png" alt="leftshade" className="leftshade" />
        <img src="/midshade.png" alt="leftshade" className="midshade" />

        <Navbar />
        <section className="forgot-password">
          <div className="custom-container">
            {/* <Link to="/forgot"><button className='btn-back'><img src="\assets\forgot\arrow-left.svg" alt="img" className='img-fluid' />Back</button></Link> */}
            <div className="parent-card">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="162"
                height="49"
                viewBox="0 0 162 49"
                fill="none"
              >
                <path
                  d="M12.6218 0.620605L0.495117 13.7358V22.2423L27.2173 48.933L53.9276 22.2566V18.8216H21.3008L23.5619 25.9135H38.7424L27.2149 37.4328L8.90431 19.1364L18.2017 9.09371H36.2282L40.2012 13.3899H52.4282V12.1161L41.7985 0.620605H12.6218Z"
                  fill="#329879"
                />
                <path
                  d="M77.2573 25.8057V22.1704H87.8632V34.9774H84.5947L83.961 31.8424C82.2267 34.3104 79.6586 35.5111 76.2234 35.5111C72.7882 35.5111 70.0533 34.3771 67.9855 32.1092C65.9177 29.8413 64.8838 26.8396 64.8838 23.1042C64.8838 19.3688 65.9177 16.3671 68.0522 14.0659C70.1534 11.8313 73.0216 10.6973 76.6236 10.6973C79.5919 10.6973 82.0599 11.4644 84.0611 12.9653C85.9955 14.4994 87.1961 16.5339 87.5963 19.1353H82.9604C82.6269 17.7346 81.8932 16.634 80.7592 15.8335C79.6253 15.0331 78.2578 14.6329 76.657 14.6329C74.4557 14.6329 72.7548 15.3999 71.4874 16.9008C70.2201 18.435 69.5864 20.5028 69.5864 23.1042C69.5864 25.739 70.2201 27.8068 71.5208 29.3076C72.7882 30.8418 74.5558 31.5755 76.8237 31.5755C78.5914 31.5755 80.1255 31.0419 81.3929 29.9747C82.6603 28.9074 83.3273 27.54 83.4607 25.8057H77.2573Z"
                  fill="#329879"
                />
                <path
                  d="M109.563 11.231V15.2665H96.5562V20.8696H108.329V24.7384H96.5562V30.9419H109.497V34.9774H92.0537V11.231H109.563Z"
                  fill="#329879"
                />
                <path
                  d="M127.787 22.5372L131.756 11.231H138.293V34.9774H133.99V27.7401C133.99 23.3043 134.024 19.3688 134.124 15.9669C133.623 17.6345 133.023 19.4689 132.323 21.4366L127.52 34.9774H123.818L118.982 21.4366C118.115 18.9686 117.548 17.1676 117.214 16.0336C117.281 19.4355 117.348 23.3377 117.348 27.7401V34.9774H113.012V11.231H119.549L123.651 22.7707C123.918 23.5711 124.585 25.7056 125.686 29.2076C126.386 26.7395 127.086 24.5383 127.787 22.5372Z"
                  fill="#329879"
                />
                <path
                  d="M151.9 35.5111C148.665 35.5111 146.164 34.8107 144.396 33.3432C142.628 31.9091 141.728 29.8413 141.728 27.1398H146.164C146.164 28.8407 146.664 30.0414 147.664 30.7751C148.665 31.5088 150.099 31.8757 152.034 31.8757C153.568 31.8757 154.768 31.6089 155.602 31.0086C156.403 30.4082 156.836 29.5744 156.836 28.4405C156.836 27.5066 156.469 26.8062 155.769 26.306C155.069 25.839 153.801 25.4055 151.967 25.0052L149.966 24.605C144.863 23.6712 142.328 21.2699 142.328 17.401C142.328 15.3666 143.095 13.7324 144.663 12.5317C146.197 11.331 148.365 10.6973 151.133 10.6973C154.268 10.6973 156.636 11.3644 158.237 12.6984C159.838 14.0325 160.705 15.9002 160.805 18.3015H156.436C156.336 16.9675 155.869 15.9669 155.069 15.2999C154.268 14.6662 152.967 14.3327 151.2 14.3327C149.799 14.3327 148.765 14.5995 148.031 15.0998C147.298 15.6334 146.931 16.3338 146.931 17.2676C146.931 18.2348 147.264 18.9686 147.931 19.4689C148.598 20.0025 149.832 20.4361 151.567 20.7696L153.634 21.1698C156.403 21.7368 158.404 22.5706 159.638 23.6712C160.872 24.7718 161.505 26.2726 161.505 28.207C161.505 30.5416 160.638 32.3426 158.971 33.61C157.27 34.8774 154.902 35.5111 151.9 35.5111Z"
                  fill="#329879"
                />
              </svg>
              <div className="bottom-content">
                <h6>Set your password to login</h6>
                <div className="option-field">
                  <div className="material-textfield">
                        {/* use redborder and greenborder class in condition  */}
                    <input
                      placeholder="Password"
                            className=""
                      type={showPassword ? "text" : "password"}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <img
                    onClick={() => setShowPassword(!showPassword)}
                    src="\eye.svg"
                    alt="img"
                    className="img-fluid password-icon"
                  />
                </div>
                <div className="listing-item">
                  <h6>Password Must:</h6>
                  {/* use redcolor and greencolor class in condition  */}
                  <ul className="">
                    <li>Be at least 8 characters long</li>
                    <li>Have at least one uppercase</li>
                    <li>Contain at least one special character</li>
                  </ul>
                </div>
                <div className="option-field">
                  <div className="material-textfield">
                                 {/* use redborder and greenborder class in condition  */}
                    <input
                      placeholder="Confirm   Password"
                      type={showPassword1 ? "text" : "password"}
                      className=""
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      // className='iferrorinput'
                    />
                  </div>
                  <img
                    onClick={() => setShowPassword1(!showPassword1)}
                    src="\eye.svg"
                    alt="img"
                    className="img-fluid password-icon"
                  />
                </div>
                <button onClick={() => ResetPassword()} className="btn-send">
                  {loader ? "Confirming" : "Set your password & login"}
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default New_Admin_Password;
